import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, InputGroup, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import PropTypes from 'prop-types';
import DateRange from 'componentes/generic/DateRange.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete';

const URI = ApiEndpoint + 'administration/';
const FiltersDashboard = ({
  setLoadData,
  action,
  setFilters,
  useSubCustomers = false
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [customers, setCustomers] = useState(null);
  const [selectedSubcustomerDescription, setSelectedSubcustomerDescription] =
    useState('');
  const [subCustomers, setSubCustomers] = useState([]);
  const [idSubCustomer, setIdSubCustomer] = useState(null);
  const [customersLoaded, setCustomersLoaded] = useState(false);

  const [dateFrom, setDateFrom] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [dateTo, setDateTo] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const {
    register,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: { subcustomer: '' }
  });
  const getCustomers = async () => {
    setCustomers(null);

    httpClient('GET', URI + 'customers/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setCustomers(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getSubCustomers = async () => {
    setSubCustomers(null);

    httpClient(
      'GET',
      URI + 'subcustomers/' + selectedCustomer,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          var subcustList = response.data.map(item => {
            return {
              id: item.idsubcliente,
              description: item.determinanate + ' - ' + item.descripcion
            };
          });
          console.log(subcustList);
          setSubCustomers(subcustList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!customersLoaded) {
      getCustomers();
      setCustomersLoaded(true);
    }
  }, [customersLoaded]);

  useEffect(() => {
    if (selectedCustomer && useSubCustomers) getSubCustomers();
  }, [selectedCustomer]);
  return (
    <Card.Header className="py-0" style={{ padding: '8px 0 16px 0' }}>
      <Row>
        <Col xs="auto">
          <InputGroup size="sm" style={{}}>
            <InputGroup.Text
              id="inputGroup-sizing-sm"
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              Cliente
            </InputGroup.Text>
            <div style={{ width: '250px' }}>
              <select
                aria-label="Default select"
                name="idsubcliente"
                id="idsubcliente"
                size={'lg'}
                style={{
                  minWidth: '250px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  height: '30px'
                }}
                className="form-control"
                {...register('idsubcliente', {
                  required: 'Campo Requerido'
                })}
                onChange={e => {
                  setValue('idsubcliente', e.target.value, {
                    shouldValidate: true
                  });
                  setSelectedCustomer(e.target.value);
                }}
                value={`${selectedCustomer}`}
              >
                <option key={'location_0'} value="0">
                  Todos los Clientes
                </option>
                {!!customers?.length &&
                  customers.map(estado => (
                    <option key={estado.idcliente} value={estado.idcliente}>
                      {estado.razonsocial}
                    </option>
                  ))}
              </select>
            </div>
          </InputGroup>
        </Col>
        {useSubCustomers && (
          <Col>
            <InputGroup size="sm" style={{}}>
              <InputGroup.Text
                id="inputGroup-sizing-sm"
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                SubCliente
              </InputGroup.Text>
              {subCustomers && (
                <AutocompleteDropdown
                  items={subCustomers || []}
                  currentSelected={selectedSubcustomerDescription}
                  name="subcustomer"
                  register={register}
                  addButton={false}
                  errors={errors}
                  setCurrentSelected={value => {
                    setSelectedSubcustomerDescription(value.description);
                    setIdSubCustomer(value.id);
                  }}
                  setValue={setValue}
                />
              )}
            </InputGroup>
          </Col>
        )}

        <Col>
          <InputGroup size="sm" style={{}}>
            <InputGroup.Text
              id="inputGroup-sizing-sm"
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              Periodo
            </InputGroup.Text>

            <DateRange
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
          </InputGroup>
        </Col>
        <Col xs="auto">
          <Button
            type="button"
            className="mb-5"
            onClick={() => {
              if (setFilters) {
                setFilters(null);
                setFilters({
                  idCustomer: selectedCustomer,
                  idSubCustomer: idSubCustomer,
                  dateFrom: dateFrom,
                  dateTo: dateTo,
                  idStatus: 0
                });
              }

              const newFilters = {
                idCustomer: selectedCustomer,
                idSubCustomer: idSubCustomer,
                dateFrom: dateFrom,
                dateTo: dateTo,
                idStatus: 0
              };
              if (setLoadData) setLoadData(true);
              action(newFilters);
            }}
            size="sm"
          >
            Buscar
          </Button>
        </Col>
      </Row>
    </Card.Header>
  );
};
FiltersDashboard.propTypes = {
  action: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  setLoadData: PropTypes.func.isRequired,
  useSubCustomers: PropTypes.bool
};
export default FiltersDashboard;
